import { useCallback, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCommunicationList } from './useCommunicationList';
import { trackEvent } from '../../../modules/analytics/trackingMiddleware';
import { COMMUNICATION_OPENED, COMMUNICATION_FILTER_APPLIED } from '../../../modules/analytics/events';

const TABS = ['ALL', 'WHATSAPP', 'SMS', 'CALL', 'EMAIL'];

interface UseCommunicationModalProps {
  initialTab?: string;
  onClose: () => void;
}

export const useCommunicationModal = ({
  initialTab = 'ALL',
  onClose,
}: UseCommunicationModalProps) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(initialTab);

  const {
    data,
    isLoading,
    isError,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCommunicationList(activeTab);
  const communications = useMemo(
    () => (data?.pages ? data.pages.flatMap(page => page.list) : []),
    [data]
  );

  const tabCounts = data?.pages?.[0]?.tabCounts || {};

  const handleTabChange = useCallback((newValue: string) => {
    setActiveTab(newValue);
    trackEvent(COMMUNICATION_FILTER_APPLIED, { type: 'tab', tab: newValue });
  }, []);

  const handleNavigate = useCallback(() => {
    trackEvent(COMMUNICATION_OPENED, { source: 'go_to_communication_center' });
    onClose();
    navigate('/communication');
  }, [navigate, onClose]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  return {
    communications,
    tabCounts,
    error,
    isError,
    isLoading,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
    activeTab,
    setActiveTab: handleTabChange,
    handleNavigateToCommunications: handleNavigate,
    handleCloseModal: handleClose,
    markCommunication: () => { },
    tabs: TABS,
  };
}; 